import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Iframe from 'react-iframe';
import {
  Header,
  Modal,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { TRANSLATION_FILES } from '../../constants/translation';

class MarketplaceTncModal extends Component {
  static propTypes = {
    open: PropTypes.bool,
    header: PropTypes.string,
    onClose: PropTypes.func,
  }

  static getPropsToState = (props) => {
    const open = props.open;
    return {
      open,
    };
  }

  constructor(props) {
    super(props);
    const state = MarketplaceTncModal.getPropsToState(props);
    this.state = {
      ...state,
    };
  }

  componentWillReceiveProps(nextProps) {
    const state = MarketplaceTncModal.getPropsToState(nextProps);
    this.setState({ ...state });
  }

  handleOnClose = () => {
    this.props.onClose();
  }

  render() {
    const { t } = this.props;
    return (
      <Modal
        centered
        open={this.state.open}
        onClose={this.handleOnClose}
        closeIcon="close"
        size="small"
      >
        <Header as="h4" content={this.props.header} style={{ background: '#F4F5F7' }} />
        <Modal.Content centered>
          {
            this.props.header === t('Terms and Conditions') ? (
              <div style={{ textAlign: 'center' }}>
                <Iframe width="635px" height="500px" frameBorder="0" overflow="hidden" styles={{ fontSize: "14px" }} url="https://blog.mhub.my/terms/marketplace" />
              </div>
            ) : null
          }
        </Modal.Content>
      </Modal>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.screens)(MarketplaceTncModal);



// WEBPACK FOOTER //
// ./src/containers/Projects/MarketplaceTncModal.jsx